// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type ListSvgrepoCom2SvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function ListSvgrepoCom2SvgIcon(props: ListSvgrepoCom2SvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      x={"0"}
      y={"0"}
      viewBox={"0 0 500.004 500.004"}
      xmlSpace={"preserve"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M488.284 54.686H136.556c-6.472 0-11.72 5.252-11.72 11.72 0 6.476 5.248 11.72 11.72 11.72H488.28c6.472 0 11.72-5.24 11.724-11.72 0-6.472-5.248-11.72-11.72-11.72zM42.98 24.194C19.28 24.194 0 43.482 0 67.178c0 23.708 19.28 42.984 42.98 42.984 23.7 0 42.98-19.276 42.98-42.984 0-23.696-19.28-42.984-42.98-42.984zm445.304 210.18H136.556c-6.472 0-11.72 5.252-11.72 11.72 0 6.476 5.248 11.72 11.72 11.72H488.28c6.472 0 11.72-5.24 11.724-11.72 0-6.472-5.248-11.72-11.72-11.72zM42.98 206.546c-23.7 0-42.98 19.28-42.98 42.984 0 23.696 19.28 42.976 42.98 42.976 23.7 0 42.98-19.28 42.98-42.976 0-23.704-19.28-42.984-42.98-42.984zM488.284 417.97H136.556c-6.472 0-11.72 5.244-11.72 11.72 0 6.472 5.248 11.72 11.72 11.72H488.28c6.472 0 11.72-5.252 11.724-11.72 0-6.476-5.248-11.72-11.72-11.72zM42.98 389.85C19.28 389.85 0 409.126 0 432.834c0 23.696 19.28 42.976 42.98 42.976 23.7 0 42.98-19.28 42.98-42.976 0-23.708-19.28-42.984-42.98-42.984z"
        }
      ></path>
    </svg>
  );
}

export default ListSvgrepoCom2SvgIcon;
/* prettier-ignore-end */
